import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import CanadaFooter from '../components/Layout/CanadaFooter';

// Components
import AppBar from '../components/Layout/AppBar';
import BypassBlocks from '../components/Layout/BypassBlocks';

import { LANGUAGE, URL_PREFIX } from '../constants/global';

export default function DefaultLayout({ children }) {
  const location = useLocation();
  const lang = location.pathname.includes(URL_PREFIX.FR)
    ? LANGUAGE.FR
    : LANGUAGE.EN;
  const { t, i18n } = useTranslation();
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  const [name, setName] = useState(null);

  useEffect(() => {
    let firstName;
    let lastName;
    if (accounts.length > 0) {
      [firstName, lastName] = accounts[0].name.split(' ');
      setName(`${lastName}, ${firstName}`);
    }
  }, [accounts]);

  if (i18n.language !== lang) {
    return <CircularProgress />;
    // eslint-disable-next-line no-else-return
  } else {
    return (
      <>
        <BypassBlocks />
        <AppBar auth={isAuthenticated} username={name} />
        <main id="main" tabIndex="-1">
          {children}
        </main>
        <CanadaFooter
          lang={i18n.language}
          dateModified={`${
            i18n.language === LANGUAGE.FR
              ? process.env.LAST_MODIFIED_FR
              : process.env.LAST_MODIFIED_EN
          }`}
          transactional
          termsUseRouterLink
          termsRoute={`${t('common:/urlPrefix')}${t('common:/termsAndConditions')}`}
        />
      </>
    );
  }
}

// Prop Types
DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
